

// * - Browser, no env → same-origin `/api-backend/` (proxied by Next.js → backend; avoids CORS).

// * - Server (SSR) → `API_INTERNAL_BASE_URL` or `https://automationdashboardbackend.scipl.info.in/api/`.


export function getApiBaseUrl(): string {

  const fromEnv = String(process.env.NEXT_PUBLIC_API_BASE_URL ?? '').trim();

  if (fromEnv) {

    return fromEnv.endsWith('/') ? fromEnv : `${fromEnv}/`;

  }

  if (typeof window !== 'undefined') {

    return `${window.location.origin}/api-backend/`;

  }

  const host = String(process.env.NEXT_PUBLIC_BACKEND_URL ?? 'https://automationdashboardbackend.scipl.info.in/api/').trim();
  const internal = host.endsWith('/') ? `${host}api/` : `${host}/api/`;

  return internal.endsWith('/') ? internal : `${internal}/`;

}
